var m = require('mithril');
var key = require('../libs/keybindings');
var Model = require('../libs/Model');
var modal = require('../layout/components/modal');
var addressInput = require('../components/inputs/addressInput');

var Action = Object.assign(Object.create(Model), require('../../../../models/locations/Site'));

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});


Action.editDialogue = function (record, parentRecord, options) {
  Model.initForm.call(Action, record)
 
  Action.record = record ? record : undefined;
  
  var submit = function () {
    return Action.save()
    .then(response => {
      key.unbind('enter');
      options && options.submitCallback ? options.submitCallback() : '';
      modal.vm.close();
      m.redraw();
    })
  };

  var deleteSite = function () {
    return Action.delete(Action.record)
    .then(response => {
      key.unbind('enter');
      options && options.submitCallback ? options.submitCallback() : '';
      modal.vm.close();
      m.redraw();
    })
  }

  var renderEditModal = function () {
    key.unbind('enter');
    key.setScope('modal');
    key('enter', 'modal', submit);

    modal.vm.title(Action.record ? 'Edit Site: ' : 'Add Site: ')
    modal.vm.body = Action.view,
    Action.record && options && options.delete ?
      modal.vm.buttons([
        {
          label: "Delete",
          class: "dib red mr3 ",
          func: showDeleteConfirmation
        },
        {
          label: "Save",
          class: "dib",
          func: submit
        }
      ])
      :
      modal.vm.buttons([
        {
          label: "Save",
          class: "btn-good",
          func: submit
        }
      ]);
  };

  var showDeleteConfirmation = function () {
    key.unbind('enter');

    var confirmDelete = function () {
      return deleteSite();
    };

    key('enter', 'modal', confirmDelete);
    modal.vm.title(`Delete ${Action.record && Action.record.name ? Action.record.name : 'Site'}?`);
    modal.vm.body = function () {
      return m('div', [
        m('p', 'Are you sure you want to delete this location?')
      ]);
    };
    modal.vm.buttons([
      {
        label: "Cancel",
        class: "dib mr2 ",
        func: function () {
          renderEditModal();
          modal.vm.open();
        }
      },
      {
        label: "Delete",
        class: "dib red ",
        func: confirmDelete
      }
    ]);
    modal.vm.open();
  };

  Action.initAutocomplite = function initAutocomplite(){
    autocomplete = new google.maps.places.Autocomplete(
      document.getElementById('searchTextField'),{
        types:['establishment'],
        componentRestrictions: {'country': ['US']},
        fields: ['place_id', 'geometry', 'name']
      }
    )
  }

  renderEditModal();
  var modelOptions={
    extrawidth:true
  }
  modal.vm.open(modelOptions);
}


Action.view = function () {
  return m('form', {role:'form'}, [
    Action.errorView(),
    m('label', 'Name:'),
    m('input.form-control.mb2', {
      type:'text',
      oninput: (ev) => Action.form.name(ev.target.value),
      value: Action.form.name(),
    }),
    m('label', 'Latitude:'),
    m('input.form-control.mb2', {
      type:'text',
      oninput: (ev) => Action.form.latitude(ev.target.value),
      value: Action.form.latitude(),
    }),  
    m('label', 'Longitude:'),
    m('input.form-control.mb2', {
      type:'text',
      oninput: (ev) => Action.form.longitude(ev.target.value),
      value: Action.form.longitude(),
    }),
    m('label', 'GeoJson Data:'),
    m('textarea', {
      resize: 'none',
      rows:'5',
      cols:'40', 
      'box-sizing': 'border-box',
      placeholder:"Add GeoJson data here...",
      oninput: ev => Action.form.geojson(ev.target.value),
      value: Action.form.geojson()
    })
  ])
}

module.exports = Action;
